import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { OnHoldCause } from '../types/types';

const initialState:
    {
        OnHoldCauses: OnHoldCause[]

    } = {
    OnHoldCauses: []
}

const RootCauses = createSlice({
    name: 'onHoldCauses',
    initialState,
    reducers: {
        addOnHoldCauses: (state, action: PayloadAction<OnHoldCause[]>) => {
            state.OnHoldCauses = action.payload
        },
    },
});

export const { addOnHoldCauses } = RootCauses.actions;

export default RootCauses.reducer;
